import { createSelector } from 'reselect';

export const selectedStatsClaims = (state: any) => {
  return state.get('statsClaims');
};

const makeSelectStatsClaims = () =>
  createSelector(selectedStatsClaims, claims => {
    if (claims && claims.get('statsClaims')) {
      return claims.get('statsClaims').toJS();
    }
    return {};
  });

export { makeSelectStatsClaims };
